import type { DocumentGsForms as DocumentGsFormInterface } from './types'

export class DocumentGsForm implements DocumentGsFormInterface {
  form: HTMLFormElement
  paramsPrefix: string

  constructor(form: HTMLFormElement, paramsPrefix: string) {
    this.form = form
    this.paramsPrefix = paramsPrefix
  }

  addInputs(uuid: string, signedId: string, name: string): void {
    this.addHiddenInput('id', '', uuid)
    this.addHiddenInput('document_direct_upload_path', signedId, uuid)
    this.addHiddenInput('document_file_name', name, uuid)
  }

  addHiddenInput(name: string, val: string, dataId: string): void {
    const hiddenInput = document.createElement('input')
    hiddenInput.setAttribute('type', 'hidden')
    hiddenInput.setAttribute('name', `${this.paramsPrefix}[${name}]`)
    hiddenInput.setAttribute('data-id', dataId)
    hiddenInput.setAttribute('data-testid', `${this.paramsPrefix}[${name}]`)
    hiddenInput.setAttribute('value', val)
    this.form.appendChild(hiddenInput)
  }
}
